import LocalNav from './LocalNav'
export default LocalNav
